import { create } from 'zustand';

export type WhereCenter = { lat: number; lng: number };

type WhereCenterState = {
  // 검색 결과에서 마지막으로 선택한 위치의 표시 이름.
  // 지도(originalWhere)와 매칭하여 이전 선택의 좌표가 잘못 재사용되는 것을 방지한다.
  name: string | null;
  // 백엔드가 내려준 좌표. 좌표가 없으면(null) 지도는 기존 방식(이름 지오코딩)으로 폴백한다.
  center: WhereCenter | null;
  setWhereCenter: (payload: { name: string; center: WhereCenter | null }) => void;
};

// 검색 결과 선택 → 매물 페이지 지도 중심 이동을 잇는 임시 상태.
// 새로고침/링크공유 시에는 비어 있고, 그 경우 지도가 이름 지오코딩으로 폴백하므로 persist 하지 않는다.
export const useWhereCenterStore = create<WhereCenterState>((set) => ({
  name: null,
  center: null,
  setWhereCenter: ({ name, center }) => set({ name, center }),
}));
